// Revival header helpers: keeps every "Shopping as" control's label in sync with the stored customer type,
// closes the dropdown after a choice, and wires "Show everything".
(function () {
  if (window.__rvHeader) return; window.__rvHeader = true;
  var LABELS = { 'dog-breeder': 'Dog Breeder', 'cat-breeder': 'Cat Breeder', 'shelter': 'Shelter or Rescue', 'equine': 'Equine', 'vet': 'Vet Clinic' };
  function current() { return (window.RevivalCT && window.RevivalCT.get()) || document.documentElement.getAttribute('data-customer-type') || ''; }
  function paint(type) {
    document.querySelectorAll('[data-rv-shopas]').forEach(function (d) {
      var v = d.querySelector('[data-rv-shopas-value]');
      if (v) v.textContent = LABELS[type] || 'Choose';
      d.classList.toggle('is-set', !!type);
      var clear = d.querySelector('[data-rv-shopas-clear]');
      if (clear) clear.hidden = !type;
    });
  }
  document.addEventListener('revival:customer-type', function (e) {
    paint((e.detail && e.detail.type) || '');
    document.querySelectorAll('[data-rv-shopas][open]').forEach(function (d) { d.removeAttribute('open'); });
  });
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    if (t.closest('[data-rv-shopas-clear]') && window.RevivalCT) { window.RevivalCT.set(''); return; }
    // Close open dropdowns when clicking elsewhere.
    document.querySelectorAll('[data-rv-shopas][open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-rv-shopas][open]').forEach(function (d) { d.removeAttribute('open'); d.querySelector('summary').focus(); });
  });
  function boot() { paint(current()); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
